import { create } from "zustand";

interface UseGlobalLoadingState {
  globalLoading: boolean;
  switchGlobalLoading: () => void;
  // setGlobalLoading: (open: boolean) => void;
}

const useGlobalLoading = create<UseGlobalLoadingState>((set) => ({
  globalLoading: false,
  switchGlobalLoading: () =>
    set((state) => ({ globalLoading: !state.globalLoading })),
  // setGlobalLoading: (open: boolean) => set({ globalLoading: open }),
}));

export default useGlobalLoading;
